import { useRef, useState } from "react";
import { Upload } from "lucide-react";

export default function FileDropzone({ uploading, onFiles }) {
  const [drag, setDrag] = useState(false);
  const input = useRef(null);
  const drop = (e) => { e.preventDefault(); setDrag(false); onFiles(e.dataTransfer.files); };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }} onDragLeave={() => setDrag(false)} onDrop={drop}
      onClick={() => input.current?.click()} data-testid="files-dropzone"
      className={`cursor-pointer rounded-lg border-2 border-dashed p-8 flex flex-col items-center justify-center gap-2 transition-colors ${drag ? "border-amber-400 bg-amber-500/5" : "border-white/10 hover:border-amber-500/40"}`}>
      <Upload className="text-amber-400" />
      <span className="text-sm">{uploading ? `Wysyłanie... ${uploading}%` : "Przeciągnij pliki lub kliknij, aby wybrać"}</span>
      <span className="text-xs text-slate-600">.eix, .epk, .exe, .dll, .py ...</span>
      <input ref={input} type="file" multiple hidden onChange={(e) => { onFiles(e.target.files); e.target.value = ""; }} data-testid="files-upload-input" />
    </div>
  );
}
